module.exports = __webpack_public_path__ + "static/media/reading-list.16250963.png";